<template>
    <div class="detail">
        <div v-if="amplification.show" class="detail__mask" @click="detailCancel"></div>
        <div v-if="amplification.show" class="amplification__img">
            <img class="amplification__cancel" src='https://static.zc0901.com/dci-web-shop-cancel.png' @click="detailCancel" />
            <div class="amplification__btn amplification__prev" @click="prev">
                <img src='https://static.zc0901.com/dci-web-check-left.png' />
            </div>
            <div class="amplification__swiper" @click="detailCancel">
                <el-carousel 
                    ref='detailSwiper'
                    :autoplay='false' 
                    indicator-position='none'
                    :initial-index='amplification.url'
					arrow='never'
                >
                    <el-carousel-item v-for="(item,index) in seriesInfo.colors[choseSwiper].style_images" :key="index">
                        <img class="amplification__img" :src='watchFn(item)' />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="amplification__btn amplification__next" @click="next">
                <img src='https://static.zc0901.com/dci-web-check-right.png' />
            </div>
        </div>
        
        <img class="brand__top" src='https://static.zc0901.com/dci-web-bran-to-top.png' v-if="btnFlag" @click="backTop" />
        <div class="detail__header">
            <img :src='seriesInfo.backgroundImage' />
            <div>{{seriesInfo.title}}</div>
            <div>{{seriesInfo.slogan}}</div>
            <div></div>
        </div>
        <choseCard
            v-if="seriesInfo.cart"
            :title='seriesInfo.title'
            :chose='chose'
            :data='seriesInfo.cart'
            :cart='cart'
            :showImg='showImg'
            :cartData='cartData'
            @onChoseColor='onChoseColor'
            @onChoseSurface='onChoseSurface'
            @onChoseSize='onChoseSize'
            @onHandleChange='onHandleChange'
            @onAddShop='onAddShop'
        ></choseCard>
        <div class="design__inspiration">
            <img class="design__inspiration__banner" src='https://static.zc0901.com/dci-web-design-inspiration.png' />
            <img v-if="isMp4 === -1" class="design__inspiration__img" :src='designFn' />
            <videoPlayer v-else class="video-player-box-detail" ref="videoPlayer" :options="playerOptions" />
            <div class="design__inspiration__body"> 
                <div>设计灵感</div> 
                <div>{{seriesInfo.inspiration}}</div> 
            </div>
        </div>
        <div class="swiper__title">
            <div class="swiper__title__item" v-for="(item,index) in seriesInfo.colors" :key="item.id" @click="choseSwiperFn(index,item.id)">
                <div :class="choseSwiper === index ? 'swiper__title__item_chose' : ''" class="swiper__title__item_nochose" >{{item.cn}} ({{item.en}})</div>
                <div :class="choseSwiper === index ? 'swiper__title__line_chose' : ''" class="swiper__title__line_nochose" ></div>
            </div>
        </div>
        <div class="swiper__fix" v-if="seriesInfo.colors">
            <div class="swiper__fix__header">
                <div>
                    <img src='https://static.zc0901.com/dci-web-product-styory-title.png' />
                </div>
                <div>{{seriesInfo.colors[choseSwiper].story}}</div>
            </div>
            <swiper class="swiper" ref="mySwiper" :options="swiperOption" @slideChangeTransitionStart='slideChange'>
                <swiper-slide v-for="(item,index) in seriesInfo.colors[choseSwiper].style_images" :key="index">
                    <img :src='item' @click="amplificationImg(item,index)" />
                </swiper-slide>
            </swiper>
            <div class="swiper__foot">
                <div @click="swiperFoot(index)" :class="activeIndex === index ? 'swiper__chose' : ''" v-for="(item,index) in seriesInfo.colors[choseSwiper].style_images" :key="index"></div>
            </div>
        </div>
        <!-- 颜色 -->
        <div class="product__color">
            <div class="product__color__item" v-for="(item,index) in seriesColor" :key='index'>
                <div class="product__color__item__size">
                    <img src='https://static.zc0901.com/dci-web-series-color-title.png' />
                    <div>{{item.keys}}mm</div>
                </div>
                <div class="product__color__item__size__items__data">
                    <div class="product__color__item__size__items" v-for="(items,indexs) in item.values" :key="indexs">
                        <div>{{items.name}}</div>
                        <img :src='items.image' />
                    </div>
                </div>
                
            </div>
        </div>
        <div class="product__knowledge">
            <div class="product__knowledge__header">
                <div class="product__knowledge__header_cn">产品知识 / </div>
                <div class="product__knowledge__header_en">Product   Knowledge</div>
                <img src='https://static.zc0901.com/dci-web-product-knowledge.png' class="product__knowledge__header_bottom" />
            </div>
            <div class="product__knowledge__content">
                <el-collapse accordion>
                    <el-collapse-item>
                        <template slot="title">
                            <div class="product__knowledge__content__common">
                                <img src='https://static.zc0901.com/dci-web-product-knowledge-left.png' />
                                <div class="product__knowledge__content__common__content">
                                    <div>参数明细</div>
                                    <div>Parameter Details</div>
                                </div>
                            </div>
                        </template>
                        <div v-for="(item,index) in seriesInfo.params" :key="index">{{item.key}}{{item.value}}</div>
                    </el-collapse-item>
                    <el-collapse-item>
                        <template slot="title">
                            <div class="product__knowledge__content__common">
                                <img src='https://static.zc0901.com/dci-web-product-knowledge-right.png' />
                                <div class="product__knowledge__content__common__content">
                                    <div>购买须知</div>
                                    <div>Purchase Notes</div>
                                </div>
                            </div>
                        </template>
                        <div class="buy__detail" v-if="seriesInfo.purchaseNotes">
                            <div class="buy__detail__item" v-for="(item,index) in seriesInfo.purchaseNotes.options" :key="index">
                                <div>{{item.key}}</div>
                                <p>{{item.value}}</p>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import {mapState,mapActions,mapGetters} from 'vuex'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { getToken } from '@/utils/cookies'
import { videoPlayer } from "vue-video-player";
import foot from '../../components/foot/index'
import choseCard from '../seriesDetail/choseCard/index'
import 'swiper/css/swiper.css'
import "./index.scss";
	export default {
        components: {
            Swiper,
            SwiperSlide,
            foot,
            choseCard,
            videoPlayer
        },
        directives: {
            swiper: directive
        },
		data() {
			return {
                isMp4: false,
                playerOptions: {
                    width: "640",
                    height: "400",
                    autoplay: true,
                    muted: true, 
                    volume: 1,

                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [
                        {
                            type: "video/mp4",
                            src: "http://vjs.zencdn.net/v/oceans.mp4"
                        }
                    ],
                    poster:"https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg"
                },
				swiperOption: {
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                },
                activeIndex:0,
                chose: {
                    color:'',
                    surface:'',
                    size:''
                },
                cartData:{
                    area:0,
                    num:0,
                    productId:0,
                    price:'',
                    stock:0
                },
                showImg:'',
                choseSwiper:0,
                choseSwiperId:0,
                cart:{},
                btnFlag:false,
                amplification:{
                    show:false,
                    url:''
                }
			}
		},
		computed: {
            ...mapState('series',['seriesInfo','seriesColor']),
            designFn(){
                return this.seriesInfo.inspiration_image !== undefined && this.seriesInfo.inspiration_image.split('?')[0]
            }
		},
        async created(){
            await this.SERIESINFO(this.$route.query.id)
            this.showImg = this.seriesInfo.colors[0].style_images[0]
            this.cart = this.seriesInfo.cart
            this.isMp4 = this.seriesInfo.inspiration_image.indexOf('mp4') 
            this.playerOptions.sources = this.seriesInfo.inspiration_image  
            let _data = {
                id: this.$route.query.id,
                colorId: this.seriesInfo.colors[0].id
            }
            this.SERIESCOLOR(_data)
        },
		mounted() {
            window.addEventListener('scroll', this.scrollToTop)
        },
        destroyed () {
            window.removeEventListener('scroll', this.scrollToTop)
        },
		methods: {
            ...mapActions('series',['SERIESINFO','SERIESCOLOR','CHOSEPRODUCT','ADDSHOPCART']),

            // 选择颜色 
            onChoseColor(id,status,index){
                if ( this.chose.color !== id && status === false) {
                    return 
                }else{
                    this.chose.color = this.chose.color === id ? '' : id 
                    this.showImg = this.seriesInfo.colors[index].style_images[0]
                }
                this.change()
            },
            // 选择规格
            onChoseSurface(title,status){
                if ( this.chose.surface !== title && status === false) {
                    return
                }else{
                    this.chose.surface = this.chose.surface === title ? '' : title
                }
                this.change()
            },
            // 选择尺寸
            onChoseSize(title,status){
                if ( this.chose.size !== title && status === false) {
                    return
                }else{
                    this.chose.size = this.chose.size === title ? '' : title
                }
                this.change()
            },
            // 发送请求
            async change(){
                if( this.chose.color === '' && !this.chose.surface && !this.chose.size ){
                    this.cart = this.seriesInfo.cart
                    this.cartData.stock = 0
                }else{
                    // 把作出的选择发给后端
                    let _data = {
                        id:this.$route.query.id,
                        color: this.chose.color,
                        size: this.chose.size,
                        surface: this.chose.surface
                    }
                    const res = await this.CHOSEPRODUCT(_data)
                    if( res.code === 200 ){
                        this.cart = res.data.cart
                        this.cartData.area = res.data.area
                        this.cartData.productId = res.data.productId
                        this.cartData.price = res.data.cart.price
                        this.cartData.stock = res.data.cart.stock
                    }
                }
            },
            // 修改数量
            onHandleChange(currentValue){
                this.cartData.num = currentValue
            },
            // 添加购物车
            async onAddShop(){
                if( this.cartData.num === 0 ) return this.$message.error('选购商品数量为0')
                // 没有登陆跳转登陆页面
                if( getToken('DCI_USER') == undefined ){
                    this.$message.error('您还没有登录，请先登录')
                    return this.$router.push({
                        path: `../login`
                    })
                } 
                // 登陆过
                if( this.chose.color === '' || !this.chose.surface || !this.chose.size ){
                    if (this.chose.color !== '' && this.cartData.stock === 0) {
                        return this.$message.error('当前商品库存为0，无法添加购物车')
                    };
                    return this.$message.error('请做完选择');
                }
                let _data = {
                    productId: this.cartData.productId,
                    number: this.cartData.num
                }
                const res = await this.ADDSHOPCART(_data)
                if( res.code === 200 ){
                    this.$message({
                        message: '成功添加购物车',
                        type: 'success'
                    });
                }
            },
            // 数据整合
            dataIntegration(newArray,oldArray){

            },
            async choseSwiperFn(index,id){
                this.choseSwiper = index
                this.choseSwiperId = id
                let _data = {
                    id:this.$route.query.id,
                    colorId:id
                }
                await this.SERIESCOLOR(_data)
            },
            slideChange(){
                
                this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
            },
            // 点击轮播底部切换
            swiperFoot(index){
                this.activeIndex = index
                this.$refs.mySwiper.$swiper.slideTo(index, 1000, false)
            },
            // 点击放大图片
            amplificationImg(data,index){
                this.amplification.show = true
                this.amplification.url = index
            },
            // 放大图片
            prev(){
                this.$refs.detailSwiper.prev()
            },
            next(){
                this.$refs.detailSwiper.next()
            },
            // 取消放大图片
            detailCancel(){
                this.amplification.show = false
            },
            backTop () {
                const that = this
                let timer = setInterval(() => {
                    let ispeed = Math.floor(-that.scrollTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                    if (that.scrollTop === 0) {
                        clearInterval(timer)
                    }
                }, 16)
            },
            scrollToTop () {
                const that = this
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                that.scrollTop = scrollTop
                if (that.scrollTop > 0) {
                    that.btnFlag = true
                } else {
                    that.btnFlag = false
                }
            },
            watchFn(url){
                return url.split('?')[0] 
            }
        }
	}
</script>
<style lang="scss">
    .detail{
        .el-carousel__container{
            width: 1000px;
            height: 560px;
        }
        .el-carousel__item{
            width: 1000px;
            img{
                width: auto;
                height: 560px;
            }
        }
    }
    .swiper {
        height: 320px;
        width: 740px;
        min-width: 860px;
        position: absolute;
        left: 460px;
        .swiper-slide {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            font-weight: bold;
            cursor: pointer;
        }
        .swiper-pagination{

        }
    }
    .swiper-slide {
        width: auto;
        img{
            width: auto;
            height: 100%;
            border-radius: 4px;
        }
    }
    .product__knowledge__content{
        
        .el-collapse{
            background: none;
            width: 960px;
        }
        .el-collapse>div:nth-of-type(1){
            width: 320px;
        }
        .el-collapse-item__header{
            height: 58px;
            background: none;
            border: none;
        }
        .el-collapse-item:nth-of-type(2){
            width: 320px;
        }
        .el-collapse-item__header.is-active{
            width: 320px;
        }
        .el-collapse{
            border: none;
            display: flex;
            justify-content: space-between;
        }
        .el-collapse-item__wrap{
            background: none;
            border-bottom: none;
            width: 960px;
            text-align: left;
            div{
                margin-bottom: 24px;
            }
            div:nth-of-type(1){
                margin-top: 24px;
            }
            div:nth-last-child(1){
                margin-bottom: 0;
            }
        }
        .el-icon-arrow-right:before{
            color: white;
        }
        .el-collapse-item__content{
            width: 960px;
            font-size:16px;
            font-weight:400;
            color:rgba(229,229,229,1);
            line-height:20px;
        }
        .el-collapse-item:nth-of-type(2){
            .el-collapse-item__wrap{
                margin-left: -640px;
            }
        }
    }
</style>
